import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import { decryptdata } from "../utils/encryptDecrypt";

// Create Saga middleware
const sagaMiddleware = createSagaMiddleware();


 

// Custom middleware to decrypt data
const decryptMiddleware = store => next => action => {
  console.log("Dispatching:", action);

  try {
    if (action?.data?.data) {
      const updatedAction = {
        ...action,
        data: JSON.parse(decryptdata(action.data?.data)) // CRA example
        // data: decryptdata(action.data, import.meta.env.VITE_PUBKEY) // Vite example
      };
      return next(updatedAction);
    }
  } catch (error) {
    console.error("Error decrypting action data:", error);
  }

  // Pass action as is if no data to decrypt
  return next(action);
};

// Configure store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }) // Disable thunk when using saga
      .concat(sagaMiddleware)
      .concat(decryptMiddleware),
});

// Run saga
sagaMiddleware.run(rootSaga);

export default store;
